import { ThemeProvider } from '@mui/material/styles'
import { lightTheme } from '../../../themes'
import { FC } from 'react'

const SweepstakesThemeProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <ThemeProvider theme={lightTheme}>{children}</ThemeProvider>
}

export default SweepstakesThemeProvider
